export default __webpack_public_path__ + "static/media/cover4.4bd51d11.jpg";